export enum ActivityType {
    Unknown = 'Unknown',
    Like = 'Like',
    AtMention = 'AtMention',
    GroupMention = 'GroupMention',
    MeMention = 'MeMention',
    FileMention = 'FileMention',
    GroupAtAllMention = 'GroupAtAllMention',
    TxpRentalCarReservation = 'TxpRentalCarReservation',
    TxpFlightReservation = 'TxpFlightReservation',
    TxpLodgingReservation = 'TxpLodgingReservation',
    TxpFoodEstablishmentReservation = 'TxpFoodEstablishmentReservation',
    TxpEventReservation = 'TxpEventReservation',
    TxpParcelDelivery = 'TxpParcelDelivery',
    TxpInvoice = 'TxpInvoice',
    TxpServiceReservation = 'TxpServiceReservation',
    UserAtMentioned = 'UserAtMentioned',
}

export type ActivityFeedStorageItem = {
    id: string;
    version: string;
    type: ActivityType;
    expiry: Date;
    isSeen: boolean;
    isRead: boolean;
    isDismissed: boolean;
    priority: string;
    activityFeedItemPayload: string;
    timeOfAction: string;
    aggregationKey: string;
    timestamp: Date;
};
